import { render, staticRenderFns } from "./seatBinding.vue?vue&type=template&id=e0527e70&scoped=true&"
import script from "./seatBinding.vue?vue&type=script&lang=js&"
export * from "./seatBinding.vue?vue&type=script&lang=js&"
import style0 from "./seatBinding.vue?vue&type=style&index=0&id=e0527e70&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0527e70",
  null
  
)

export default component.exports